module.exports = __webpack_public_path__ + "img/new-icon.74d2eca.svg";